import {FC,useReducer} from "react";
import { ALERTS, REMOVE_ALERTS } from "../action";
import AlertContext from "./AlertContext";
import AlertReducer from "./AlertReducer";

const AlertState:FC = (props) => {
    const initialState: never[]= [];
    const[state,dispatch] = useReducer(AlertReducer,initialState);

    const setAlert = (sucessmsg:string, err:string, autoHideDuration = 5000) =>{
        const id = Math.random();
        dispatch({
            type: ALERTS,
            payload: {id,sucessmsg,err,autoHideDuration}
        })
        if (autoHideDuration > 0) {
            setTimeout(() => dispatch({
                type: REMOVE_ALERTS,
                payload: id
            }), autoHideDuration)
        }
    }
    return (
        
        <AlertContext.Provider value={{
            alert: state,
            setAlert
        }}>
            {props.children}
        </AlertContext.Provider>
    )
}

export default AlertState 